import { gql } from 'apollo-angular';

export const RemoveFunnelTacticDocument = gql(/* GraphQL*/ `mutation removeFunnelTactic($funnelTacticId: Int!) {
  removeFunnelTactic (funnelTacticId: $funnelTacticId)
}
`);
